export default class GuidelineDetailsCtrl {
  constructor ($scope, $mdDialog, PortfolioSrv, PortfolioModalSrv, GlobalConfig) {
  // constants
    var guidelineVm = this
    const sharedVariable = PortfolioModalSrv.getVariable()
    guidelineVm.guideline = sharedVariable.guideline
    guidelineVm.guideline.text = (guidelineVm.guideline.active == 1 ? 'Activo' : 'Inactivo')
  // methods
    guidelineVm.close = close

    activate()
    function activate() {
      
    }  

    function close () {
      return $mdDialog.hide()
    }  
    

  }
}

GuidelineDetailsCtrl.$inject = ['$scope', '$mdDialog', 'PortfolioSrv', 'PortfolioModalSrv', 'GlobalConfig']



// WEBPACK FOOTER //
// ./src/app/u-faculty/portfolio/parametrization/modals/guidelineDetailsCtrl.js